import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { QR_TYPES } from '../data/qrRegistry';

const QrTypePills = observer(({ store }) => {
  const types = Object.values(QR_TYPES);

  return (
    <Box
      overflowX="auto"
      mx={-1}
      px={1}
      sx={{ scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' } }}
    >
      <HStack spacing={1.5} minW="max-content">
        {types.map((t) => {
          const active = store.qrTypeId === t.id;
          return (
            <Box
              key={t.id}
              as="button"
              px={3}
              py={1.5}
              borderRadius="full"
              fontSize="sm"
              fontWeight={active ? '600' : '400'}
              whiteSpace="nowrap"
              transition="all 0.12s"
              bg={active ? 'blue.500' : 'transparent'}
              color={active ? 'white' : 'gray.600'}
              _hover={{ bg: active ? 'blue.600' : 'gray.100', color: active ? 'white' : 'gray.700' }}
              _dark={{
                color: active ? 'white' : 'gray.300',
                bg: active ? 'blue.500' : 'transparent',
                _hover: { bg: active ? 'blue.600' : 'whiteAlpha.100' },
              }}
              onClick={() => store.setQrType(t.id)}
            >
              <Text as="span" mr={1}>{t.icon}</Text>
              {t.label}
            </Box>
          );
        })}
      </HStack>
    </Box>
  );
});

export default QrTypePills;
